import React, { createContext, type ReactNode } from 'react';
import { type UserAttributes } from '@soulhx/fs-common';
import { useUserDetailsQuery } from '@soulhx/client-store';

export type SoulHXContextType = {
  user: UserAttributes;
};

export const SoulHXContext = createContext<SoulHXContextType | null>(null);

interface ISoulHXContextProvider {
  children?: ReactNode;
}
export const SoulHXContextProvider = ({ children }: ISoulHXContextProvider) => {
  const { data: user } = useUserDetailsQuery();

  if (!user) return null;

  return <SoulHXContext value={{ user }}>{children}</SoulHXContext>;
};
